export default [
    {
        name:'msgList',
        path:'list',
        component(resolve) {
            require(['@/components/student/msg/list'], resolve)
        },
        meta: {
            keepAlive : true,
            title : '消息中心'
        }
    },
    {
        name:'msgList-new',
        path:'list-new',
        component(resolve) {
            require(['@/components/student/msg/list-new'], resolve)
        },
        meta: {
            keepAlive : true,
            title : '消息中心'
        }
    },
    {
        path:'detail/:id',
        component(resolve) {
            require(['@/components/student/msg/detail'], resolve)
        },
        meta: {  
            title : '消息详情'
        }
    }
]




// WEBPACK FOOTER //
// ./src/router/student/msg.js